import { useQuery } from "react-query";
import { PaginateQuery, PaginateResult } from "core/resources/types/shared";
import axios from "infra/http";
import { PerfilListItem } from "../typings";

function useGetPerfis(tenantId?: string, filtro?: PaginateQuery) {
  return useQuery(["/v1/perfil", filtro], async () => {
    const { data } = await axios.get<PaginateResult<PerfilListItem>>(
      "/v1/perfil",
      {
        params: { ...filtro, tenantId },
      }
    );

    return data;
  });
}

export default useGetPerfis;
